import {
  useQuery,
  useMutation,
  useQueryClient
} from '@tanstack/react-query'

import { scenarioQueryKeys } from '../queryKeys'
import { resourcefulScenarioRequest } from '../requests'

export function useLiabilitiesQuery({
  scenarioID,
  initialData,
  queryKey
}) {
  const queryClient = useQueryClient()
  // NOTE: We should contain a list of scenario resources
  // and reference liabilities from there
  const liabilityRequests = resourcefulScenarioRequest(
    scenarioID, 'liabilities'
  )

  const liabilitiesQuery = useQuery({
    queryFn: liabilityRequests.index,
    queryKey,
    initialData
  })

  const updateLiabilityMutation = useMutation({
    mutationFn: liabilityRequests.update,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [scenarioQueryKeys(scenarioID).liabilities] })
      queryClient.invalidateQueries({ queryKey: [scenarioQueryKeys(scenarioID).forecasts] })
    },
  })

  const createLiabilityMutation = useMutation({
    mutationFn: liabilityRequests.create,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [scenarioQueryKeys(scenarioID).liabilities] })
      queryClient.invalidateQueries({ queryKey: [scenarioQueryKeys(scenarioID).forecasts] })
    },
  })

  const deleteLiabilityMutation = useMutation({
    mutationFn: liabilityRequests.delete,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [scenarioQueryKeys(scenarioID).liabilities] })
      queryClient.invalidateQueries({ queryKey: [scenarioQueryKeys(scenarioID).forecasts] })
    },
  })

  const isFetching = liabilitiesQuery.isFetching || updateLiabilityMutation.isLoading

  const isAnyLoading = liabilitiesQuery.isFetching ||
    createLiabilityMutation.isLoading ||
    updateLiabilityMutation.isLoading ||
    deleteLiabilityMutation.isLoading

  return {
    data: liabilitiesQuery.data,
    actions: {
      update: updateLiabilityMutation.mutateAsync,
      create: createLiabilityMutation.mutateAsync,
      delete: deleteLiabilityMutation.mutateAsync,
    },
    status: liabilitiesQuery.status,

    /* Boolean flags indicating various states of status */
    isFetching: isFetching,
    isAnyLoading: isAnyLoading
  }
}
